<template>
  <v-dialog v-model="addDialog" class="the-app-dialogs" persistent max-width="700px">
    <v-card>
      <form @submit.prevent="validateBeforeSubmit($event)">
        <v-layout row class="no-select" style="background-color:#09132f">
          <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
            <v-layout align-center>
              <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">fa-users</v-icon>
              <span class="px-3">{{ $t('Add New Customer') }}</span>
            </v-layout>
          </h3>
          <v-spacer />
          <v-card-actions>
            <v-btn fab icon dark @click="$emit('hidemodal')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-layout>

        <v-card-title class="grey lighten-3">
          <v-layout column>
            <v-layout row wrap>
              <v-flex xs12 class="pa-2">
                <v-text-field
                  ref="customer_focus_me"
                  v-model="form.customer_name"
                  :label="`${$t('Customer Name')} *`"
                  name="customer_name"
                  box
                  hide-details
                  background-color="white"
                  :error="errors.has('customer_name')"
                  v-validate="'required'"
                />
              </v-flex>

              <v-flex xs11 pa-2>
                <v-autocomplete
                  v-model="form.customer_groups_id_fk"
                  :items="fullCustomersGroupsList"
                  :label="`${$t('Group')}`"
                  box
                  hide-details
                  background-color="white"
                  :error="errors.has('customer group')"
                  data-vv-name="customer group"
                  :menu-props="{ transition: 'slide-y-transition' }"
                />
              </v-flex>

              <v-flex xs1 pt-2 v-if="hasPermissions(['customer_groups_store'])">
                <v-tooltip top>
                  <v-btn label @click="$emit('add-group')" slot="activator" icon fab small color="green">
                    <v-icon color="white" size="25">add</v-icon>
                  </v-btn>
                  <span>{{ $t('Add new customer group') }}</span>
                </v-tooltip>
              </v-flex>

              <!--              <v-flex pa-2>-->
              <!--                <v-autocomplete-->
              <!--                  v-model="form.sale_man_id_fk"-->
              <!--                  :items="fullSaleManList"-->
              <!--                  :label="`${$t('Salesman')}`"-->
              <!--                  box-->
              <!--                  hide-details-->
              <!--                  background-color="white"-->
              <!--                  :error="errors.has('Salesman')"-->
              <!--                  data-vv-name="Salesman"-->
              <!--                  :menu-props="{ transition: 'slide-y-transition' }"-->
              <!--                />-->
              <!--              </v-flex>-->

              <!--              <v-flex xs1 pt-2 v-if="hasPermissions(['sale_man_store'])">-->
              <!--                <v-tooltip top>-->
              <!--                  <v-btn label @click="$emit('add-salesman')" slot="activator" icon fab small color="green">-->
              <!--                    <v-icon color="white" size="25">add</v-icon>-->
              <!--                  </v-btn>-->
              <!--                  <span>{{ $t('Add new salesmen') }}</span>-->
              <!--                </v-tooltip>-->
              <!--              </v-flex>-->

              <v-flex xs12 sm4 class="pa-2">
                <v-text-field
                  v-model="form.customer_phone"
                  :label="$t('Phone')"
                  name="customer_phone"
                  box
                  hide-details
                  background-color="white"
                  :error="errors.has('customer_phone')"
                />
              </v-flex>

              <v-flex xs12 sm8 class="pa-2">
                <v-text-field
                  v-model="form.customer_mail"
                  :label="$t('Email')"
                  name="customer_mail"
                  box
                  hide-details
                  background-color="white"
                  autocomplete="off"
                  :error="errors.has('customer_mail')"
                  v-validate="'email'"
                  data-vv-validate-on="blur"
                />
              </v-flex>

              <v-flex xs12 sm4 class="pa-2">
                <v-autocomplete
                  v-model="form.customer_country"
                  :items="countriesList"
                  :label="`${$t('Country')}`"
                  box
                  hide-details
                  browser-autocomplete
                  background-color="white"
                  :menu-props="{ transition: 'slide-y-transition' }"
                />
              </v-flex>

              <v-flex xs12 sm4 class="pa-2">
                <v-text-field
                  v-model="form.customer_governorate"
                  :label="$t('Governorate')"
                  name="customer_governorate"
                  box
                  hide-details
                  background-color="white"
                  autocomplete="off"
                  :error="errors.has('customer_governorate')"
                />
              </v-flex>

              <v-flex xs12 sm4 class="pa-2">
                <v-text-field
                  v-model="form.customer_city"
                  :label="$t('City')"
                  name="customer_city"
                  box
                  hide-details
                  background-color="white"
                  autocomplete="off"
                  :error="errors.has('customer_city')"
                />
              </v-flex>

              <v-flex xs12 class="pa-2">
                <v-textarea
                  v-model="form.customer_address"
                  :label="$t('Address')"
                  name="customer_address"
                  box
                  hide-details
                  height="80"
                  background-color="white"
                  :error="errors.has('customer_address')"
                />
              </v-flex>
            </v-layout>
          </v-layout>
        </v-card-title>
        <v-divider light />

        <v-card-actions class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="pb-2 px-2" style="color: #444;"
              >- {{ $t('Fields marked with asterisk ( * ) are required.') }}</v-flex
            >

            <v-layout justify-end align-center pr-2 pl-2>
              <v-checkbox color="primary" v-model="keepForm" :label="$t('Keep this form to add another one.')" />

              <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Cancel') }}</v-btn>
              <v-btn type="submit" color="success" :loading="btnAddLoading">
                <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
                {{ $t('Add') }}
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'

export default {
  name: 'add-component',

  props: {
    addDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      btnAddLoading: false,
      form: {},
      keepForm: false
    }
  },

  computed: {
    ...mapGetters({
      // fullSaleManList: 'salesmen/getFullSalesmanList',
      fullCustomersGroupsList: 'customersGroups/getFullGroupsList',
      countriesList: 'locale/getCountriesList'
    })
  },

  watch: {
    addDialog: {
      immediate: false,
      handler() {
        if (this.addDialog) {
          this.addEscKeyListener()
          this.resetForm()
          this.keepForm = false
        }
      }
    }
  },

  methods: {
    ...mapActions({
      addCustomer: 'customers/addCustomer',
      // updateFullSaleManList: 'salesmen/updateFullSalesmanList',
      updateFullGroupsList: 'customersGroups/updateFullGroupsList'
    }),

    hasPermissions(permissions) {
      return helpers.userHasPermissions(permissions)
    },

    addEscKeyListener() {
      document.addEventListener('keyup', e => {
        // if the "ESC" button was pressed and this dialog is shown, hide it
        if (e.keyCode === 27 && this.addDialog) {
          this.$emit('hidemodal')
        }
      })
    },

    resetForm() {
      this.$validator.pause()
      for (let key in this.form) {
        this.form[`${key}`] = null
      }
      this.$nextTick(() => {
        this.$validator.resume()
        // default veutify autofocus only one time works so we have to handled in this way.
        // document.getElementById('customer-focus-me').focus()
      })
    },

    validateBeforeSubmit(event) {
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          this.btnAddLoading = true

          let formData = new FormData(event.target)
          formData.append('customer_groups_id_fk', this.form.customer_groups_id_fk || '')
          // formData.append('sale_man_id_fk', this.form.sale_man_id_fk || '')
          formData.append('customer_country', this.form.customer_country || '')

          // for (let pair of formData.entries()) {
          //   console.warn(`${pair[0]}: ${pair[1]}`)
          // }

          this.addCustomer(formData)
            .then(() => {
              this.btnAddLoading = false
              this.$emit('reset-datatable')
              if (this.keepForm) {
                this.resetForm()
              } else {
                this.$emit('hidemodal')
              }
            })
            .catch(() => {
              this.btnAddLoading = false
            })
        }
      })
    }
  }
}
</script>

<style scoped />
